<template>
  <ExpansionPanels :data="bets" :loading="loading" />
</template>
<script>
import ExpansionPanels from "@/components/my-bets/expansion-panels.vue";
import { listBetsCashout } from "@/util/my-bets";
export default {
  components: {
    ExpansionPanels,
  },
  data: () => ({
    bets: [],
    loading: true,
  }),
  mounted() {
    this.getListBetsCashout();
  },
  methods: {
    async getListBetsCashout() {
      try {
        this.loading = true;
        this.bets = await listBetsCashout(4);
      } catch (error) {
        const msg = this.$t("noBetsFound");
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
